import { SetPasswordContainer } from 'src/containers/Authentication';
import { AuthShell, AuthHeading } from 'src/components/Layout';
import { usePageMeta } from 'src/hooks';

export default function SetPasswordProtected() {
  usePageMeta('Set Password');

  return (
    <AuthShell>
      <AuthHeading title="Set your password" description="Create a new password to secure your account." />
      <SetPasswordContainer />
    </AuthShell>
  );
}
